import React, { useEffect, useRef, useState } from "react";

const CustomSelect = ({ onChange, option, value }) => {
  const wrapperRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(value);

  // close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleSelect = (label) => {
    setSelected(label);
    setOpen(false);
    onChange?.(label);
  };

  return (
    <div
      ref={wrapperRef}
      className={`select-control js_transactionType ${open ? "active" : ""}`}
    >
      {/* SELECTED VALUE */}
      <div
        className="select-val"
        name="chaseStatus"
        translate="label_all"
        onClick={() => setOpen((p) => !p)}
      >
        {selected}
      </div>

      {/* DROPDOWN */}
      {open && (
        <div
          className="select-list mCustomScrollbar _mCS_1 mCS-autoHide"
          style={{ display: "block", overflow: "visible" }}
        >
          <div
            id="mCSB_1"
            className="mCustomScrollBox mCS-minimal mCSB_vertical mCSB_outside"
            style={{ maxHeight: "none" }}
            tabIndex={0}
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
              style={{ position: "relative", top: 0, left: 0 }}
              dir="ltr"
            >
              {option?.map((res) => {
                return (
                  <div
                    className={`item-options ${
                      selected == res ? "active" : ""
                    }`}
                    onClick={() => handleSelect(res)}
                  >
                    {res}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
